import React , {Component} from 'react';
import {
    Link
} from 'framework7-react';
class OrderCard extends Component{

    render(){
        const { object  } = this.props;
        return(
            <div className="order">
                <div className="branch-name">
                    {object.branchs_title_fa}
                    <div className={ "status step" +  object.step  }>
                        {object.step_text}
                    </div>
                </div>
                <div className="order-foods">
                    {object.foods_text}
                </div>
                <div className="order-price">
                    {object.price_payable}
                </div>
                <div className="b-row mt-3">
                    <div className="b-col-6 text-right">
                        {/*<Link className="btn rate-link">
                            امتیاز بده
                        </Link>*/}
                    </div>
                    <div className="b-col-6 text-left">
                        <Link href={`/order/${object.users_orders_ID}/`} className="btn details-link"  pushState={true}>
                            جزئیات
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default OrderCard;